import { render } from "./links.vue?vue&type=template&id=0dac12fb&scoped=true"
const script = {}

import "./links.vue?vue&type=style&index=0&id=0dac12fb&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-0dac12fb"

export default script